<template>
  <section>
    <div class="case-creation__body pb-0">
      <div class="vue-form">
        <el-form :model="patientInformation" ref="ruleForm">
          <el-row :gutter="15">
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    First Name
                    <span class="star">*</span>
                  </label>

                  <el-input
                    v-model="patientInformation.first_name"
                    placeholder="Enter First Name"
                    class="el-input"
                    @input="changeName"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.first_name"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Middle Name</label>
                  <el-input
                    v-model="patientInformation.middle_name"
                    placeholder="Enter Middle Name"
                    @input="changeName"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.middle_name"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Last Name
                    <span class="star">*</span>
                  </label>
                  <el-input
                    v-model="patientInformation.last_name"
                    placeholder="Enter Last Name"
                    @input="changeName"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.last_name"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Gender
                    <span class="star">*</span>
                  </label>
                  <div class="gender-select">
                    <el-select
                      v-model="patientInformation.gender"
                      placeholder="Gender"
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      clearable
                      @change="handlePregnancyData"
                    >
                      <el-option
                        v-for="(gender, index) in genderOptions"
                        :key="index"
                        :label="gender"
                        :value="gender"
                      ></el-option>
                    </el-select>
                  </div>
                  <p class="err">
                    <FormError errorName="patient_info.gender"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="date-of-birth case-creation__input">
                <dobVersion
                  v-if="showPatientDob"
                  :dobData="patientInformation"
                  :validataionErrors="getErrors"
                  :errorKey="'patient_info.date_of_birth'"
                  ref="dobField"
                ></dobVersion>
              </div>
            </el-col>

            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">EMR</label>
                  <el-input
                    v-model="patientInformation.emr"
                    placeholder="Enter EMR"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.emr"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input mobile-icon">
                <el-form-item>
                  <label for="text">
                    Mobile Number
                    <span class="star">*</span>
                  </label>
                  <el-input
                    v-model="patientInformation.home_phone"
                    placeholder="Enter Mobile Number"
                    maxlength="10"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.home_phone"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input mobile-icon">
                <el-form-item>
                  <label for="text">Phone Number</label>
                  <el-input
                    v-model="patientInformation.work_phone"
                    placeholder="Enter Phone Number"
                    maxlength="10"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.work_phone"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="7" :lg="7" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Email</label>
                  <el-input
                    v-model="patientInformation.email"
                    placeholder="Enter Email"
                    class="el-input email-lower"
                    type="email"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.email"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="7" :lg="7" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Address Line 1
                    <span class="star">*</span>
                  </label>
                  <el-input
                    v-model="patientInformation.address_line_1"
                    placeholder="Enter Address Line 1s"
                    class="el-input"
                  ></el-input>
                  <p class="err">
                    <FormError
                      errorName="patient_info.address_line_1"
                    ></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Address Line 2</label>

                  <el-input
                    v-model="patientInformation.address_line_2"
                    placeholder="Enter Address Line 2"
                    class="el-input"
                  ></el-input>
                  <p class="err">
                    <FormError
                      errorName="patient_info.address_line_2"
                    ></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>

            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">
                    Zip
                    <span class="star">*</span>
                  </label>
                  <el-input
                    v-model="patientInformation.zip"
                    placeholder="Enter Zip"
                    maxlength="5"
                    @input="getStateCity"
                  ></el-input>

                  <p class="err">
                    <FormError errorName="patient_info.zip"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="date-of-birth case-creation__input">
                <el-form-item>
                  <label for="text">County</label>
                  <el-input
                    placeholder="Enter County"
                    v-model="patientInformation.county"
                  ></el-input>
                  <p class="err">
                    <FormError errorName="patient_info.county"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="date-of-birth case-creation__input">
                <el-form-item>
                  <state
                    v-show="showDob"
                    :stateData="patientInformation"
                  ></state>
                  <p class="err">
                    <FormError errorName="patient_info.state"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="date-of-birth case-creation__input">
                <el-form-item>
                  <city
                    v-if="showDob"
                    :cityData="patientInformation"
                  ></city>
                  <p class="err">
                    <FormError errorName="patient_info.city"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Race</label>
                  <div class="gender-select">
                    <el-select
                      v-model="patientInformation.race"
                      placeholder="Select Race"
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      clearable
                    >
                      <el-option
                        v-for="(race, index) in raceOptions"
                        :key="index"
                        :label="race"
                        :value="race"
                      ></el-option>
                    </el-select>
                  </div>
                  <p class="err">
                    <FormError errorName="patient_info.race"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="3" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input">
                <el-form-item>
                  <label for="text">Ethnicity</label>
                  <div class="gender-select">
                    <el-select
                      v-model="patientInformation.ethnicity"
                      placeholder="Select Ethnicity"
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      clearable
                    >
                      <el-option
                        v-for="(ethnicity, index) in ethnicityOptions"
                        :key="index"
                        :label="ethnicity"
                        :value="ethnicity"
                      ></el-option>
                    </el-select>
                  </div>
                  <p class="err">
                    <FormError errorName="patient_info.ethnicity"></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
              <div class="case-creation__input mobile-icon">
                <el-form-item>
                  <label for="text">Medical Record Id</label>
                  <el-input
                    v-model="patientInformation.medical_record_id"
                    placeholder="Enter Medical Record Id"
                    maxlength="15"
                    :disabled="isDisabled"
                  ></el-input>
                  <p class="err">
                    <FormError
                      errorName="patient_info.medical_record_id"
                    ></FormError>
                  </p>
                </el-form-item>
              </div>
            </el-col>
            <el-col
              :xl="4"
              :lg="3"
              :md="8"
              :sm="12"
              :xs="12"
              v-if="patientInformation.gender == 'FEMALE'"
            >
              <div class="pregancy-field">
                <label for="">Pregnancy </label>
                <el-form-item class="text mb-0">
                  <el-checkbox
                    class="el-checkbox-group"
                    v-model="patientInformation.pregnant"
                    size="large"
                  />
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
const state = defineAsyncComponent(() =>
  import("@/components/misc/BillingState")
);
const city = defineAsyncComponent(() =>
  import("@/components/misc/BillingCity")
);
const dobVersion = defineAsyncComponent(() =>
  import("@/components/misc/DobNewFormat")
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
export default {
  props: ["patientInfo"],
  data() {
    return {
      ethnicityOptions: caseConstants.ethnicityOptions,
      raceOptions: caseConstants.raceOptions,
      //patient information
      patientInformation: {
        first_name: "",
        middle_name: "",
        last_name: "",
        gender: "",
        date_of_birth: "",
        emr: "",
        pms_or_pws: "",
        home_phone: "",
        work_phone: "",
        email: "",
        address_line_1: "",
        address_line_2: "",
        county: "",
        city: "",
        state: "",
        zip: "",
        race: "",
        ethnicity: "",
        pregnant: false,
      },
      genderOptions: caseConstants.genderOptions,
      show: false,
      showDob: false,
      showPatientDob: false,
      patientInsurance: {},
    };
  },
  components: {
    state,
    city,
    dobVersion,
    FormError,
  },
  computed: {
    ...mapGetters("cases", [
      "getStateAndCity",
      "getVerifyAddress",
      "getAddress",
    ]),
    ...mapGetters("errors", ["getErrors"]),
    ...mapGetters("orders", ["getCaseInformation"]),
  },
  mounted() {
    this.loadInitData();
  },
  methods: {
    async handlePregnancyData() {
      if (this.patientInformation.gender != "FEMALE") {
        this.patientInformation.pregnant = false;
      }
    },
    async loadInitData() {
      this.show = true;
      this.showPatientState = true;
      this.showPatientDob = true;
      this.showDob = true;
      if (this.$route.params.order_id) {
        this.orderId = this.$route.params.order_id;
        this.checkCaseInfo();
      }
    },
    changeName() {
      this.$emit("changeValues", this.patientInformation);
    },
    checkCaseInfo() {
      if (this.getCaseInformation && this.getCaseInformation.patient_info) {
        this.patientInformation = {
          ...this.getCaseInformation.patient_info,
        };
      }
    },
    formatPatientInfo() {
      return this.parsePatientInfo(this.patientInformation);
    },
    async getStateCity() {
      try {
        let params = {
          zip: this.patientInformation.zip,
        };
        await this.$store.dispatch("cases/getStateCity", params);
        if (this.getStateAndCity) {
          this.patientInformation.state = this.getStateAndCity.state;
          this.patientInformation.city = this.getStateAndCity.city;
        } else {
          if (!this.getStateAndCity && params.zip.length == 5) {
            this.$message({
              message: "No State & City Found",
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    parsePatientInfo(patientInfo) {
      let params = { ...patientInfo };
      if (!params.work_phone) delete params.work_phone;
      if (!params.middle_name) delete params.middle_name;
      if (!params.home_phone) delete params.home_phone;
      if (!params.address_line_1) delete params.address_line_1;
      if (!params.address_line_2) delete params.address_line_2;
      if (!params.race) delete params.race;
      if (!params.ethnicity) delete params.ethnicity;
      if (!params.pregnant) delete params.pregnant;
      if (params.email) {
        params.email = params.email.toLowerCase();
      }
      return params;
    },
  },
  watch: {
    "patientInformation.last_name": {
      immediate: true,
      handler: function () {
        if (this.patientInformation.last_name) {
          this.$emit("updateInsurance", this.patientInsurance);
        }
      },
    },
  },
};
</script>
